import React, { useState, useEffect, createContext, useContext } from 'react';

const LoadingContext = createContext({
  isLoaded: false,
  setIsLoaded: () => {},
  deferredLoad: () => {}
});

export const LoadingProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [deferredLoaded, setDeferredLoaded] = useState(false);

  useEffect(() => {
    // Set initial load
    if (document.readyState === 'complete') {
      setIsLoaded(true);
    } else {
      window.addEventListener('load', () => setIsLoaded(true));
      return () => window.removeEventListener('load', () => setIsLoaded(true));
    }
  }, []);

  useEffect(() => {
    if (isLoaded) {
      // Defer non-critical operations
      const timer = setTimeout(() => {
        setDeferredLoaded(true);
      }, 1000); // 1 second after main content loads
      
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);

  const deferredLoad = (callback) => {
    if (deferredLoaded) {
      return callback();
    }
    return null;
  };

  return (
    <LoadingContext.Provider value={{ isLoaded, deferredLoaded, deferredLoad }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
